import Select, { DropdownOption } from '../../shared/components/select';
import clsx from 'clsx';

export type DateError = { month: boolean; day: boolean; year: boolean };

const months: DropdownOption[] = [
  { value: '01', label: 'Jan' },
  { value: '02', label: 'Feb' },
  { value: '03', label: 'Mar' },
  { value: '04', label: 'Apr' },
  { value: '05', label: 'May' },
  { value: '06', label: 'Jun' },
  { value: '07', label: 'Jul' },
  { value: '08', label: 'Aug' },
  { value: '09', label: 'Sep' },
  { value: '10', label: 'Oct' },
  { value: '11', label: 'Nov' },
  { value: '12', label: 'Dec' },
];

const getCurrentYear = () => {
  return new Date().getFullYear();
};

const getDaysInMonth = (month: string, year: string) => {
  return new Date(Number(year), Number(month), 0).getDate().toString();
};

const generateYears = (startYear: number, endYear: number): DropdownOption[] => {
  const years: DropdownOption[] = [];

  for (let i = endYear; i >= startYear; i--) {
    years.push({ value: i.toString(), label: i.toString() });
  }
  return years;
};

const getDays = (daysInMonth: number) => {
  const days: DropdownOption[] = [];
  for (let i = 1; i <= daysInMonth; i++) {
    days.push({ value: i.toString(), label: i.toString() });
  }

  return days;
};

const getMonths = () => {
  return months;
};

type DateDropdownsProps = {
  onChange: (day: string, month: string, year: string) => void;
  value: string;
  error: DateError;
};

const DateDropdowns: React.FC<DateDropdownsProps> = ({ onChange, error, value }) => {
  const arr = value.split('-');
  const selectedMonth = arr[1] || '';
  const selectedYear = arr[0] || '';
  const selectedDay = arr[2] || '';

  const handleDayChange = (day: string) => {
    const formatDay = day.length === 1 ? `0${day}` : day;
    onChange(formatDay, selectedMonth, selectedYear);
  };

  const handleMonthChange = (month: string) => {
    const newDay = getDaysInMonth(month, selectedYear);
    if (Number(selectedDay) <= Number(newDay)) {
      onChange(selectedDay, month, selectedYear);
    } else {
      onChange(newDay, month, selectedYear);
    }
  };

  const handleYearChange = (value: string) => {
    const newDay = getDaysInMonth(selectedMonth, value);
    if (Number(selectedDay) <= Number(newDay)) {
      onChange(selectedDay, selectedMonth, value);
    } else {
      onChange(newDay, selectedMonth, value);
    }
  };

  const daysInMonth = selectedMonth ? getDaysInMonth(selectedMonth, selectedYear) : 31;
  const years = generateYears(getCurrentYear() - 100, getCurrentYear());
  const days = getDays(Number(daysInMonth));
  const months = getMonths();

  return (
    <div className="w-full flex gap-5">
      <Select
        value={selectedMonth}
        triggerClassName={clsx('flex-1', { 'text-red-error border-red-error': error.month })}
        contentClassName="z-[60]"
        options={months as DropdownOption[]}
        onChange={handleMonthChange}
        placeholder="Month"
      />

      <Select
        value={selectedDay ? Number(selectedDay).toString() : ''}
        triggerClassName={clsx('flex-1', { 'text-red-error border-red-error': error.day })}
        contentClassName="z-[60]"
        options={days as DropdownOption[]}
        onChange={handleDayChange}
        placeholder="Day"
      />

      <Select
        value={selectedYear}
        triggerClassName={clsx('flex-1', { 'text-red-error border-red-error': error.year })}
        contentClassName="z-[60]"
        options={years as DropdownOption[]}
        onChange={handleYearChange}
        placeholder="Year"
      />
    </div>
  );
};

export default DateDropdowns;
